module.exports = __webpack_public_path__ + "static/media/why-pledje-img.eb8c7393.png";